import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

// ―――― estilos -------------------------------------------------
const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 9,
    fontFamily: "Helvetica",
  },
  headerRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 10,
  },
  logo: { width: 60, height: 60, marginRight: 12 },
  titleBlock: { flexDirection: "column" },
  title: { fontSize: 14, fontWeight: "bold" },
  info: { fontSize: 9 },

  tableHeader: {
    flexDirection: "row",
    borderBottom: 1,
    paddingBottom: 4,
    marginBottom: 4,
    fontWeight: "bold",
  },
  th: { textAlign: "center", width: "14%" },
  tr: { flexDirection: "row", borderBottom: 1, paddingVertical: 3 },
  td: { textAlign: "center", width: "14%" },

  totals: { marginTop: 12, textAlign: "right", fontSize: 9 },
});

// ―――― helpers -------------------------------------------------
const formatDate = (d) =>
  new Date(d).toLocaleDateString("pt-BR", { timeZone: "UTC" });

const formatCurrency = (v) =>
  (parseFloat(v) || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

// ―――― documento ----------------------------------------------
const CaixaReportPDF = ({ filtros, data, totals }) => {
  // n° linhas = soma dos items
  const totalLinhas = data.reduce((s, c) => s + c.items.length, 0);

  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        {/* cabeçalho ------------------------------------------------ */}
        <View style={styles.headerRow}>
          <Image
            src={require("../../assets/img/achemed-simbolo-azul.png")}
            style={styles.logo}
          />
          <View style={styles.titleBlock}>
            <Text style={styles.title}>Relatório de Caixa</Text>
            <Text style={styles.info}>
              Período:&nbsp;
              {filtros.date_from || "início"} ⟶ {filtros.date_to || "hoje"}
            </Text>
            {filtros.payment_method && (
              <Text style={styles.info}>
                Método:&nbsp;{filtros.payment_method}
              </Text>
            )}
          </View>
        </View>

        {/* cabeçalho da tabela ------------------------------------- */}
        <View style={styles.tableHeader} fixed>
          <Text style={styles.th}>Data</Text>
          <Text style={styles.th}>Paciente</Text>
          <Text style={styles.th}>Procedimento</Text>
          <Text style={styles.th}>Executante</Text>
          <Text style={styles.th}>Solicitante</Text>
          <Text style={styles.th}>Venda</Text>
          <Text style={styles.th}>Status</Text>
        </View>

        {/* linhas -------------------------------------------------- */}
        {data.map((cashier, i) =>
          cashier.items.map((it, j) => (
            <View key={`${i}-${j}`} style={styles.tr}>
              <Text style={styles.td}>{formatDate(cashier.created_at)}</Text>
              <Text style={styles.td}>{cashier.patient.name}</Text>
              <Text style={styles.td}>{it.procedure_name}</Text>
              <Text style={styles.td}>{it.executing_company || "—"}</Text>
              <Text style={styles.td}>{it.requesting_company || "—"}</Text>
              <Text style={styles.td}>{formatCurrency(it.selling_price)}</Text>
              <Text style={styles.td}>
                {cashier.status === "paid" ? "Pago" : "Pendente"}
              </Text>
            </View>
          ))
        )}

        {/* totalizadores ------------------------------------------ */}
        <View style={styles.totals}>
          <Text>Registros: {totalLinhas}</Text>
          <Text>Total Venda: {formatCurrency(totals.total_gross)}</Text>
          <Text>Total Custo: {formatCurrency(totals.total_cost)}</Text>
        </View>
      </Page>
    </Document>
  );
};

export default CaixaReportPDF;
